import CurrentCastRelationshipSection from './CurrentCastRelationshipSection';
import MaterialIconSwipeAnimation from './MaterialIconSwipeAnimation';
import type { ScenePersona } from '../types';

interface AddSceneArtistsBoxProps {
  firstPersona: ScenePersona | null;
  secondPersona: ScenePersona | null;
  onAddSceneArtist: (slot: 'first' | 'second') => void;
}

const AddSceneArtistsBox = ({
  firstPersona,
  secondPersona,
  onAddSceneArtist
}: AddSceneArtistsBoxProps) => {
  const castRelationship: any = {
    personAName: firstPersona?.nickname,
    personAThumbnailUrl: firstPersona?.dataUrl,
    personBName: secondPersona?.nickname,
    personBThumbnailUrl: secondPersona?.dataUrl
  };

  return (
    <div className="mt-[34px]">
      <CurrentCastRelationshipSection
        currentCastRelationship={castRelationship}
        gap={25}
        onPersonAClick={() => onAddSceneArtist('first')}
        onPersonBClick={() => onAddSceneArtist('second')}
        showCameraIcon={true}
      >
        <MaterialIconSwipeAnimation />
      </CurrentCastRelationshipSection>
    </div>
  );
};

export default AddSceneArtistsBox;
